<template>
  <div class="mt-32">
    <p class="placeholder-glow d-block mb-8">
      <span
        class="placeholder bg-skeleton"
        style="width: 60%; height: 24px"
      ></span>
    </p>

    <p class="placeholder-glow d-block mb-0">
      <span
        class="placeholder bg-skeleton mr-16"
        style="width: 15.5%; height: 20px"
      ></span>
      <span
        class="placeholder bg-skeleton"
        style="width: 31%; height: 20px"
      ></span>
    </p>
  </div>

  <p class="placeholder-glow d-block mb-0">
    <span
      class="placeholder bg-skeleton mt-16"
      style="width: 95%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 98.5%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 95%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 98.8%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 94.5%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 98.5%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 98.2%; height: 16px"
    ></span>
    <span
      class="placeholder bg-skeleton mt-8"
      style="width: 66%; height: 16px"
    ></span>
  </p>
</template>

<style lang="scss" scoped>
.placeholder {
  border-radius: 100px;
  display: inline-block;
}
</style>
